import { render } from "./PaymentPage.vue?vue&type=template&id=e47cc9fa&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=e47cc9fa&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47cc9fa"]])

export default __exports__